module.exports = __webpack_public_path__ + "static/media/hp_bootcamp.53e99c76.png";